import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Printer, ArrowLeft } from "lucide-react";

export default function CoverSchoolDocument() {
  const { docType } = useParams();
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/cover-school/document/${docType}`)
      .then((r) => setDoc(r.data))
      .catch((e) => setError(formatApiError(e.response?.data?.detail)));
  }, [docType]);

  if (error) return <div className="mx-auto max-w-2xl px-5 py-24 text-center text-muted-foreground">{error} <Link to="/dashboard" className="text-primary underline">Back to portal</Link></div>;
  if (!doc) return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;

  return (
    <div className="mx-auto max-w-3xl px-5 py-10 lg:px-8">
      <div className="mb-6 flex items-center justify-between print:hidden">
        <Link to="/dashboard" className="inline-flex items-center gap-2 label-caps text-muted-foreground hover:text-primary"><ArrowLeft className="h-4 w-4" /> Portal</Link>
        <Button onClick={() => window.print()} className="rounded-none label-caps bg-primary hover:bg-primary/80" data-testid="cs-doc-print"><Printer className="mr-2 h-4 w-4" /> Print / Save PDF</Button>
      </div>
      <div className="cs-document rounded-none border border-border bg-white p-10 text-black shadow-brutal" data-testid="cs-document" dangerouslySetInnerHTML={{ __html: doc.html }} />
      <style>{`
        .cs-document h1 { font-size: 1.6rem; font-weight: 800; margin-bottom: .5rem; }
        .cs-document h3 { font-size: 1.05rem; font-weight: 700; margin-top: 1.1rem; }
        .cs-document p, .cs-document li { line-height: 1.6; margin: .5rem 0; }
        .cs-document ul { padding-left: 1.2rem; list-style: disc; }
        .cs-document table td, .cs-document table th { border: 1px solid #333; }
        @media print { header, footer, .print\\:hidden { display: none !important; } .cs-document { border: 0; box-shadow: none; } }
      `}</style>
    </div>
  );
}
